import React, { useEffect } from "react";
import { Field, useFormikContext } from 'formik'

const UsuarioCuenta = ({familiaUsuario, handleAtras}) => {

  const { resetForm } = useFormikContext();
  useEffect(() => {
    let usuario = document.querySelector('#usuario');
    usuario.select()
    document.execCommand('copy')
  }, [])
  
  return (
    <>
      <div className="text-center w-full">
        <p className="font-bold text-white text-base w-full">
          Su nombre de usuario (alias familia) es:
        </p>
        <input
        type="text"
        id="usuario"
        name="usuario"
        className="flex flex-col w-full items-center mb-2 rounded-md border-gray-300  focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
        value={familiaUsuario}
        ></input>
        <div
        className="flex flex-row gap-2"
        >
          <button
          className="w-full mt-1 px-4 py-2 font-bold bg-azulBrillanteMira hover:bg-secundario transition duration-500  text-white rounded-lg"
          onClick={(e)=>{handleAtras(e.target); resetForm()}}
          name="usuarioFinal"
          >Atrás
          </button>
        <div className=" flex w-full text-center">      
            <a
             className="w-full mt-1 px-4 py-2 font-bold bg-azulBrillanteMira hover:bg-secundario transition duration-500  text-white rounded-lg"
             href="/campus/login">Finalizar</a>
        </div>
        </div>
      </div>
    </>
  );
};

export default UsuarioCuenta;
